export const resetPassword = {
    title: '重置密码',
    newPassword: '新密码',
    confirmNewPassword: '重新输入新密码',
    resetSuccess: '您已成功重置密码',
    buttonSave: '保存',
};
